import script from "./index.vue?vue&type=script&setup=true&name=orderList&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=orderList&lang=js"

const __exports__ = script;

export default __exports__